<template>
    <div class="bg-white w-full" :style="pageStyles">
        <slot v-if="loaded" />
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { useBuilder } from '../store/builder.store'
import { useBuilderStyles } from '../store/builder-style.store'
import { setAuthState } from "../composables/auth";

const route = useRoute()
const router = useRouter()
const id = route.params.id

const current_url = new URL(window.location.href)
const current_user = JSON.parse(current_url.searchParams.get('user'))

const { setUser } = setAuthState();
setUser(current_user)

const builder = useBuilder()

const builderStyle = useBuilderStyles()
builderStyle.isPreview = true
const { page: pageStyles } = storeToRefs(builderStyle)

// load actual builder to store
builder.isPreview = true
builder.init(id, router.replace, route)
const { loaded } = storeToRefs(builder)
</script>